import { useEffect, useState } from 'react';

/**
 * Draft name and stationIds for the connection settings page,
 * hydrated from the server connection payload.
 */
export function useConnectionSettingsDraft(
  serverName: string,
  connectionStationIds: string[] | undefined,
) {
  const [name, setName] = useState('');
  const [stationIds, setStationIds] = useState<string[]>([]);
  const connectionStationIdsKey = (connectionStationIds ?? []).join(',');

  // Hydrate draft custom name when connection data loads or server value changes.
  useEffect(() => {
    setName(serverName);
  }, [serverName]);

  // Hydrate draft selection when connection data loads or server assignments change.
  useEffect(() => {
    setStationIds(connectionStationIdsKey ? connectionStationIdsKey.split(',') : []);
  }, [connectionStationIdsKey]);

  return { name, setName, stationIds, setStationIds };
}
